import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import usePlanTasksNavigator from '../planTasksNavigator';
import DetailBoxesDatesWidgetLayout, {
  DetailBoxesDatesWidgetItem,
} from '../../../shared/widgets/DetailBoxesDates/DetailBoxesDatesWidgetLayout';
import { useListContext, useShowContextRequired } from 'ui-builder';
import {
  Plan,
  PLAN_PROJECT_TYPE_UPDATED,
  PlanTask,
  ProjectDetailsFieldType,
  useProjectDetailsFieldsService
} from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';

export default function DetailBoxesDatesWidget() {
  const showContext = useShowContextRequired<Plan>();
  const projectDetailsService = useProjectDetailsFieldsService();

  const listContext = useListContext<PlanTask>();
  const planTasksNavigator = usePlanTasksNavigator();

  const {
    data: detailsFields,
    loading
  } = useDataLoaderNew(
    async () => {
      const projectType = showContext.data.projectType;
      if (projectType) {
        return projectDetailsService.getFieldsApplicableForPlan(showContext.data.id);
      } else {
        return [];
      }
    },
    {
      dependencies: [showContext.data.projectType],
      events: [PLAN_PROJECT_TYPE_UPDATED],
    }
  );

  const dateLinks = useMemo<DetailBoxesDatesWidgetItem[]>(() => {
    if (detailsFields) {
      const fieldIdToTaskMap = listContext.data!.reduce((acc, task) => {
        if (task.linkedFieldId) {
          acc[task.linkedFieldId] = task;
        }

        return acc;
      }, {} as Record<number, PlanTask>);

      return detailsFields
        .filter((item) => item.fieldType === ProjectDetailsFieldType.DATE)
        .sort((item1, item2) => {
          const item1Order = item1.order || 0;
          const item2Order = item2.order || 0;

          return item1Order - item2Order;
        })
        .map((item) => {
          const task = fieldIdToTaskMap[item.id];

          return ({
            task: task ? {
              id: task.id,
              name: task.name,
            } : undefined,
            linkedField: item!,
            openEditTaskForm: () => {
              if (task) {
                planTasksNavigator.openEditTaskForm(task)
              }
            },
          });
        }) || [];
    } else {
      return [];
    }
  }, [listContext.version, detailsFields, showContext.data.projectType, showContext.data._setupArea?.id]);

  if (dateLinks.length > 0) {
    return (
      <DetailBoxesDatesWidgetLayout fields={dateLinks} loading={loading} pageContext="plan-tasks" />
    );
  } else {
    return null;
  }
}

export function DetailBoxesDatesWidgetPortalPlacer() {
  const listContext = useListContext();

  if (listContext.data) {
    const container = document.getElementById('details-box-dates');

    if (container) {
      return (
        ReactDOM.createPortal(
          <DetailBoxesDatesWidget />,
          container,
        )
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
}
